<template>
    <main class="main" id="main">
        <div class="top_line">
            <div class="container">
                <h1>Подарки</h1>
            </div>
        </div>
        <!----------Section gifts------------->

        <section class="section s-gifts">
            <div class="container">

                <div class="gift_choice">
                    <h1>Категория</h1>
                    <button type="button" class="choice_toggle" id="choice_toggle"></button>
                    <div class="choice_box">
                        <div class="checkbox_list_inner" v-for="(category, id) in categories" :key="id">
                            <input type="checkbox" name="filterWrap" class="auto" :checked="filterWrap===id?true:false" @click="filterWrap=id" :value="id" :id="'auto'+id">
                            <label :for="'auto'+id" class="one_choice"></label>
                            <span @click="filterWrap=id">{{category}}</span>
                        </div>
                    </div>
                </div>

                <div class="gift_box">
                    <div class="gift_cards">

                        <div class="gift_inner" v-for="present in presents" :key="present.id" v-if="filterWrap === '1' || parseInt(filterWrap) === present.category_id">
                            <div class="gift_title">
                                <h2>{{present.title}}</h2>
                            </div>
                            <img :src="present.photo" alt="">
                            <p>{{present.desc}}</p>
                            <h3>{{present.price}} бонусов</h3>
                            <div v-if="!user.access">Авторизуйтесь что бы купить подарок</div>
                            <button type="button" class="menu_item_btn" v-else-if="present.price <= user.bonus" @click="buyPresent(present)">Получить</button>
                            <div class="" v-else>Не хватает {{parseInt(present.price - user.bonus)}} бонусов</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section_b">
            <div class="container">
                <div class="title">
                    <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/restrunt_card/main/big_van_24.svg" alt="big_van_24">
                    <h1>Круглосуточная доставка еды </h1>
                </div>

                <p>
                    Служба доставки еды "ХОЧУ-ПОЕСТЬ.РФ" в городе {{city.name}} - это свыше 1000 блюд и напитков, которые привезут вам домой или в офис без наценок и дополнительной комиссии от лучших ресторанов Вашего города. Есть из чего выбрать! Вы видите то, что Вы заказываете, и точно знаете стоимость, которую нужно заплатить.
                </p>
            </div>

        </section>
    </main>

</template>

<script>
import axios from '@/router/http'
export default {
  name: 'presents',
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      presents: {},
      categories: [],
      filterWrap: '1'
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  methods: {
    buyPresent (present) {
      if (this.user.bonus >= present.price) {
        var formData = new FormData()
        formData.append('id', present.id)
        formData.append('uid', this.auth.uid)
        axios.post('https://lk.when-hungry.com/mobile/buy-present',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(response => {
          if (response.data.text) alert(response.data.text)
          if (response.data.link) window.location.replace(response.data.link)
        })
      }
    },
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/presents-get?uid=' + this.auth.uid).then(response => {
        this.presents = response.data.presents
        this.categories = response.data.categories
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/presents.vue